import * as React from 'react';

const ReportIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
    <path
      d="M15 12V2.51654C15 1.79862 14.2659 1.31459 13.6061 1.59739L1.60608 6.74025C1.2384 6.89783 1 7.25937 1 7.6594V22C1 22.5523 1.44772 23 2 23H8"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 18C14 17.4477 14.4477 17 15 17H16C16.5523 17 17 17.4477 17 18V22C17 22.5523 16.5523 23 16 23H15C14.4477 23 14 22.5523 14 22V18Z"
      fill={props.stroke}
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19 9C19 8.44772 19.4477 8 20 8H22C22.5523 8 23 8.44772 23 9V12H19V9Z"
      fill={props.stroke}
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 13C8 12.4477 8.44772 12 9 12H23V22C23 22.5523 22.5523 23 22 23H8V13Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const SvgRefundProtectIcon = (props ) => (
  <svg width="149" height="67" viewBox="0 0 149 67" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path 
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.6553 0.790019C8.40583 4.88713 -3.51942 23.4157 0.935852 40.7525C1.59198 43.3074 2.82387 46.7935 3.67307 48.4996C9.98688 61.1897 24.4314 68.7029 38.606 66.6698C47.2656 65.4279 52.5511 62.4361 61.8929 53.4887L68.3969 47.2594L64.6792 43.5491L60.9616 39.8383L54.5015 45.997C49.6849 50.5891 47.0309 52.645 44.0683 54.0803C40.3165 55.8979 39.7558 56.0054 34.0131 56.0054C28.5948 56.0054 27.5629 55.8359 24.5574 54.4501C19.9912 52.3447 17.1435 50.0225 14.7722 46.4681C11.9749 42.2748 10.8777 38.6322 10.8777 33.5345C10.8777 16.3951 28.2554 5.6665 44.1567 12.9892C47.7397 14.6395 50.122 16.7939 72.1093 38.2699C94.8528 60.4848 96.3668 61.8462 100.279 63.5887C114.031 69.7133 128.661 67.2881 138.966 57.1756C147.562 48.7391 150.893 37.0251 147.953 25.5655C146.173 18.6263 144.174 15.1009 139.212 10.1527C134.224 5.1784 128.76 2.19004 122.158 0.825858C114.086 -0.841544 107.961 -0.0382785 100.017 3.73058C95.2314 6.001 93.8695 7.03069 87.6169 13.1035L80.5932 19.9262L84.4542 23.7258L88.3152 27.5253L95.1557 20.8768C104.111 12.1717 106.345 11.0635 114.932 11.0635C120.566 11.0635 121.284 11.1949 124.919 12.8891C142.675 21.1663 142.675 45.9026 124.919 54.1799C121.284 55.874 120.566 56.0054 114.932 56.0054C104.913 56.0054 105.917 56.7234 78.8023 30.1536C53.7512 5.60506 51.7209 3.95814 43.2503 1.30884C39.3858 0.0999605 30.9082 -0.165139 26.6553 0.790019Z"
      fill="currentColor"/>
  </svg>
);
export  {ReportIcon,SvgRefundProtectIcon};




